const ACCESS_LEVELS = {
    ACCESS: "access",
    ADMIN: "admin",
    NEW_SPECIMEN: "newspecimen",
    DAILY_HUSBANDRY: "dailyhusbandry",
    READ_ONLY: "readonly",
    VENOM_EXTRACTION: "venom_extraction",
    VENOM_PROFILE: "venomprofile",
    DAILY_EXTRACTION: "dailyextraction",
    MONTHLY_POOL_VENOM_LOTS: "monthlypoolvenomlots",
    RELEASE_CERTIFICATE: "release_certificate",
    VET_MED_TEAM: "vet_med_team",
    MEDICAL_RECORD_ACCESS: "medical_record_access"
}

function hasPermissions(userAccessRights, requiredPermissions, denyReadOnly, ignoreAdmin) {
    if (denyReadOnly) {
        // only check read only if we have requested it be checked
        // this is a special access level because we need to refuse authorisation when a user *has* it, instead of when the user does not have it
        if (userAccessRights[ACCESS_LEVELS.READ_ONLY]) {
            return false;
        }
    }

    if (!ignoreAdmin) {
        // both access and admin => you always have permission (except when you have the read only "permission")
        if (userAccessRights[ACCESS_LEVELS.ADMIN] && userAccessRights[ACCESS_LEVELS.ACCESS]) {
            return true;
        }
    }

    for (var i = 0; i < requiredPermissions.length; i++) {
        if (!userAccessRights[requiredPermissions[i]]) {
            return false;
        }
    }

    return true;
}

module.exports = {
    ACCESS_LEVELS,
    hasPermissions
}